import { render, staticRenderFns } from "./BlockListContactGroupCustom.vue?vue&type=template&id=3ba3192e&"
import script from "./BlockListContactGroupCustom.vue?vue&type=script&lang=js&"
export * from "./BlockListContactGroupCustom.vue?vue&type=script&lang=js&"
import style0 from "./BlockListContactGroupCustom.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports